import {
  AdvancedMarker,
  ControlPosition,
  Map,
  MapControl,
  RenderingType,
  useAdvancedMarkerRef,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getUrl, radiusZoomLevel } from "../../utils/staticMethods";
import MapDetail from "../detail/MapDetail";
// import CommonMapItems from "./CommonMapItems";
import useAuth from "../../hooks/useAuth";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import * as queryString from "query-string";
import axios from "axios";
import api from "../../api";
import GoogleSearch from "./GoogleSearch";
import TrackingSearch from "./TrackingSearch";
import ButtonsControl from "./ButtonsControl";
import CommonMapTrafficLayer from "./CommonMapTrafficLayer";
import useCommonMap from "../../hooks/useCommonMap";
import CommonMapFloorplans from "./CommonMapFloorplans";
import useSrlHelper from "../../hooks/useSrlHelper";
import { imageSet } from "../../pages/icons/AssetIcon/IconList";
import defaultImg from "../../assets/img/icon/Aircraft/Airliner_Black.png";
import ReaderSelector from "../../pages/readers/ReaderSelector";
import { Card } from "react-bootstrap";
import { Grid, Link } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartbeat } from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import InfoWindow from "../mapComponents/InfoWindow";
import CommonMapNearByItems from "./CommonMapNearByItems";
import { createPortal } from "react-dom";

const thingsArr = {
  asset: "assets",
  person: "people",
  zone: "zones",
  assets: "assets",
  people: "people",
  zones: "zones",
};

const CommonMapInitializer = ({ children }) => {
  const { map: commonMapInstance, setMap } = useCommonMap();
  const map = useMap();
  const lastMapRef = useRef(null);

  useEffect(() => {
    if (!map || !setMap) return;
    if (lastMapRef.current === map) return; // no-op if same instance
    lastMapRef.current = map;
    setMap(map);
    return () => {
      // clear only if the same map is being unmounted
      if (lastMapRef.current === map) {
        lastMapRef.current = null;
        setMap(null);
      }
    };
  }, [map, setMap]);

  return (
    <React.Fragment>
      {commonMapInstance && <React.Fragment>{children}</React.Fragment>}
    </React.Fragment>
  );
};

const CommonMapContainer = ({ showStreetView, handleMapChange, children }) => {
  return (
    <>
      <Map
        reuseMaps={true}
        // defaultCenter={{ lat: 54.0, lng: -2.5 }}
        defaultCenter={{ lat: 53.9619, lng: -2.7597 }}
        // 53.96189535344679, -2.759744216724262
        defaultZoom={8}
        defaultHeading={0}
        mapId={"90f87356969d889c"}
        // mapId={"15431d2b469f209e"}
        // mapId={"8c732c82e4ec29d9"}
        gestureHandling="cooperative"
        renderingType={RenderingType.VECTOR}
        mapTypeControlOptions={{
          position: ControlPosition.LEFT_BOTTOM,
        }}
        onIdle={handleMapChange}
        // onCenterChanged={handleMapChange}
        onBoundsChanged={handleMapChange}
        clickableIcons={false}
        tiltInteractionEnabled={false}
        headingInteractionEnabled={false}
        zoomControl={false}
        cameraControl={true}
        streetViewControl={showStreetView}
        fullscreenControl={true}
        fullscreenControlOptions={{ position: ControlPosition.RIGHT_TOP }}
        // onMapTypeIdChanged={handleMapChange}
        // onZoomChanged={handleMapChange}
        // onCenterChanged={handleMapChange}
        // onDragend={handleMapChange}
        // ref=
      >
        <CommonMapInitializer>{children}</CommonMapInitializer>
      </Map>
    </>
  );
};

const CommonMap = ({
  height,
  type = null,
  id = null,
  data = null,
  center = null,
  showMapDetail = false,
  showGoogleSearch = false,
  showStreetView = true,
  showTrackingSearch = false,
  showNearByAssets = false,
  showNearByZones = false,
  showAllLabels = false,
  showHashTagFilter = false,
  showCategoryFilter = false,
  showTrafficLayer = false,
  showReaders = false,
  floorplanMode = "",
  focusMode = "",
  geofenceFloorplan = null,
  onFloorplanChanged,
  onSelectedReaderChanged,
  onSelectedGeometryChanged,
  onMapReady,
  children,
}) => {
  // const commonMap = useCommonMap();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { reportid } = queryString.parse(location.search);
  const [report, setReport] = useState();
  const [hashtag, setHashtag] = useState(null);
  const [category, setCategory] = useState(null);
  const [firstLoad, setFirstLoad] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [nearbyItems, setNearbyItems] = useState([]);
  const [clusteredItemIds, setClusteredItemIds] = useState([]);
  // const [mapParams, setMapParams] = useState({});
  // const [selectedFloorplan, setSelectedFloorplan] = useState(null);
  const [readers, setReaders] = useState([]);
  const [selectedReader, setSelectedReader] = useState(null);
  const [showReader, setShowReader] = useState(false);

  const {
    current,
    setCurrent,
    selectedFloorplan,
    // setSelectedFloorplan,
    // floorplanImage,
    // setFloorplanImage,
    editFloorplanEnabled,
    focusedObject,
    map,
    mapLibCore,
    following,
    setFollowing,
    showInfoIds,
    setShowInfoIds,
    zonesMarkersRef,
    markersStateRef,
    bumpGroupsVersion,
    center: mapCenter,
    setCenter,
    zoom: mapZoom,
    setZoom,
  } = useCommonMap();

  const { id: currentId } = current ?? { id: null };
  const currentIdRef = useRef(currentId);
  const currentRef = useRef(current);
  const currentPositionRef = useRef(null);
  const followingRef = useRef(following);

  const mapParamsRef = useRef({});
  const cancelTokenSourceRef = useRef(null);

  useEffect(() => {
    currentRef.current = current;
  }, [current]);

  const throttleAsync = useCallback((fn, wait) => {
    let lastRun = 0;
    let timeout;
    let running = false;

    const fnResult = async function (...args) {
      const now = Date.now();
      const run = async () => {
        running = true;
        lastRun = now;
        try {
          // await fn.apply(this, args);
          await fn(args);
        } finally {
          running = false;
        }
      };
      if (running || now - lastRun < wait) {
        clearTimeout(timeout);
        timeout = setTimeout(run, Math.max(wait - (now - lastRun), 0));
      } else {
        await run();
      }
    };

    return fnResult;
  }, []);

  useEffect(() => {
    currentIdRef.current = currentId;
    if (!map) return;

    const latitude = current?.lastPosition?.latitude;
    const longitude = current?.lastPosition?.longitude;
    if (latitude && longitude) {
      let newCenter = {
        lat: Number(current.lastPosition.latitude),
        lng: Number(current.lastPosition.longitude),
      };
      map.setCenter(newCenter);
      map.setZoom(18);
    }
  }, [currentId, map]);

  useEffect(() => {
    followingRef.current = following;
    // If following has been set, set map center to the selected items position
    if (following && currentRef.current && currentRef.current.lastPosition) {
      const latitude = currentRef.current.lastPosition.latitude;
      const longitude = currentRef.current.lastPosition.longitude;
      if (latitude && longitude) {
        let newCenter = {
          lat: Number(latitude),
          lng: Number(longitude),
        };
        map.setCenter(newCenter);
      }
    }
  }, [following]);

  useEffect(() => {
    if (!map) return;
    if (!focusMode) return;
    if (!focusedObject) return;
    if (!mapLibCore) return;

    if (focusMode === "zone" && focusedObject) {
      if (focusedObject.latitude && focusedObject.longitude) {
        map.setCenter(
          new mapLibCore.LatLng(
            Number(focusedObject.latitude),
            Number(focusedObject.longitude)
          )
        );
      }
    }
  }, [map, focusMode, focusedObject, mapLibCore]);

  // useImperativeHandle(ref, () => ({
  //   showFindAddress: () => {},
  //   getMap: () => commonMap && commonMap.map,
  //   getCenter: () => commonMap && commonMap.map && commonMap.map.getCenter(),
  //   setSelectedFloorplan: handleSelectedFloorplanChanged,
  // }));

  const onSelectReader = (reader) => {
    setSelectedReader(reader);
    onSelectedReaderChanged && onSelectedReaderChanged(reader);
  };

  useEffect(() => {
    if (!data) return;
    if (!map) return;

    setCurrent(data);

    // if (!data.lastPosition) return;

    // setCurrent((prevState) => {
    //   if (prevState) {
    //     if (
    //       followingRef.current &&
    //       prevState.lastPosition &&
    //       (prevState.lastPosition.latitude !== data.lastPosition.latitude ||
    //         prevState.lastPosition.longitude !== data.lastPosition.longitude)
    //     ) {
    //       return data;
    //     }
    //     return prevState;
    //   } else {
    //     // map.setZoom(16);
    //     let latitude = data.lastPosition?.latitude;
    //     let longitude = data.lastPosition?.longitude;
    //     if (latitude && longitude) {
    //       map.setCenter({ lat: Number(latitude), lng: Number(longitude) });
    //     }
    //     return data;
    //   }
    // });

    // if (followingRef.current) {
    //   const center = map.getCenter();
    //   const zoom = map.getZoom();
    //   if (!center) return;
    //   {
    //     const update = {
    //       latitude: data.lastPosition?.latitude
    //         ? Number(data.lastPosition.latitude)
    //         : center.lat(),
    //       longitude: data.lastPosition?.longitude
    //         ? Number(data.lastPosition.longitude)
    //         : center.lng(),
    //       radius: radiusZoomLevel[Math.round(zoom)],
    //     };
    //     // if (
    //     //   prev.latitude !== update.latitude ||
    //     //   prev.longitude !== update.longitude
    //     // ) {
    //     //   map.setCenter({ lat: update.latitude, lng: update.longitude });
    //     // }
    //     // map.setZoom(update.radius);

    //     map.setCenter({ lat: update.latitude, lng: update.longitude });

    //     Object.assign(mapParamsRef.current, update);
    //   }
    // }
  }, [map, data]);

  const handleCurrentChanged = ({ current, marker }) => {
    // Only set current if we have not been passed data
    if (!data) {
      (async () => {
        current.type = thingsArr[current.type];
        let res = await api.get(`${current.type}/${current.id}`);

        let cur = res.data;
        cur.type = current.type;
        cur.showInfo = current.showInfo ?? false;
        setCurrent(cur);
      })();
    }
  };

  useEffect(() => {
    if (!map) return;
    if (followingRef.current) {
      const latitude = current?.lastPosition?.latitude;
      const longitude = current?.lastPosition?.longitude;
      if (latitude && longitude) {
        if (
          !currentPositionRef.current ||
          currentPositionRef.current.latitude !==
            current?.lastPosition?.latitude ||
          currentPositionRef.current.longitude !==
            current?.lastPosition?.longitude
        ) {
          let newCenter = {
            lat: Number(current.lastPosition.latitude),
            lng: Number(current.lastPosition.longitude),
          };
          map.setCenter(newCenter);
        }
      }
    }
    if (!currentPositionRef.current) {
      currentPositionRef.current = {};
    }
    currentPositionRef.current.latitude = current?.lastPosition?.latitude;
    currentPositionRef.current.longitude = current?.lastPosition?.longitude;
  }, [current, map]);

  const handleMapChange = useCallback(
    (e) => {
      console.log("map change", e);
      if (e.map) {
        const map = e.map;
        const eventCenter = map.getCenter();
        const zoom = map.getZoom();
        if (
          !eventCenter ||
          (mapCenter &&
            (mapCenter.lat() !== eventCenter.lat() ||
              mapCenter.lng() !== eventCenter.lng()))
        ) {
          setCenter(mapCenter);
        }
        if (zoom && mapZoom !== zoom) {
          setZoom(zoom);
        }
      }
      if (showNearByAssets === true || showNearByZones === true) {
        window.requestAnimationFrame((_time) => {
          const map = e.map;
          const center = map.getCenter();
          const zoom = map.getZoom();
          {
            const prev = mapParamsRef.current;
            const update = {
              latitude: center.lat(),
              longitude: center.lng(),
              radius: radiusZoomLevel[Math.round(zoom)],
            };
            console.log({ prev, update });
            if (
              prev.latitude &&
              Number(prev.latitude) === Number(update.latitude) &&
              prev.longitude &&
              Number(prev.longitude) === Number(update.longitude) &&
              prev.radius &&
              Number(prev.radius) === Number(update.radius)
            ) {
              // return prev;
            } else {
              const bounds = map.getBounds().toJSON();
              mapParamsRef.current = Object.assign(
                mapParamsRef.current,
                update,
                bounds
              );
              loadNearby();
            }
          }
        });
      }
    },
    [map, mapCenter, showNearByAssets, showNearByZones]
  );

  useEffect(() => {
    let update = {};
    if (reportid) {
      update.reportid = reportid;
    }
    if (hashtag) {
      update.hashtag = hashtag;
    }
    if (category) {
      update.category = category;
    }
    if (selectedFloorplan) {
      update.selectedFloorplanId = selectedFloorplan.Id;
    }
    Object.assign(mapParamsRef.current, update);

    return () => {
      delete mapParamsRef.current.reportid;
      delete mapParamsRef.current.hashtag;
      delete mapParamsRef.current.category;
      delete mapParamsRef.current.selectedFloorplanId;
    };
  }, [reportid, hashtag, category, selectedFloorplan]);

  const followCurrent = useCallback(async () => {
    if (!api || !map) return;
    if (followingRef.current) {
      if (currentRef.current) {
        const currentType = thingsArr[currentRef.current.type];
        const res = await api.get(`${currentType}/${currentRef.current.id}`);
        const currentLatest = res.data;
        const latestPosition = currentLatest?.lastPosition;
        const currentPosition = currentPositionRef.current;

        if (latestPosition && currentPosition) {
          if (
            Number(latestPosition.latitude) !==
              Number(currentPosition.latitude) ||
            Number(latestPosition.longitude) !==
              Number(currentPosition.longitude)
          ) {
            // mapParamsRef.current.latitude = latestPosition.latitude;
            // mapParamsRef.current.longitude = latestPosition.longitude;

            map.setCenter({
              lat: Number(latestPosition.latitude),
              lng: Number(latestPosition.longitude),
            });
          } else {
            // map.setCenter(map.getCenter());
          }
        }
      }
    }
    console.log("done follow");
  }, [map, api]);

  const loadNearbyInner = useCallback(async () => {
    if (cancelTokenSourceRef.current) {
      cancelTokenSourceRef.current.cancel("reload");
      cancelTokenSourceRef.current = null;
    }

    const mapParams = mapParamsRef.current;
    if (!mapParams) return -1;

    // mapParams.selectedFloorplanId
    // mapParams.reportid
    const noFloorplanSelected =
      Object.keys(mapParams).indexOf("selectedFloorplanId") === -1;
    if (noFloorplanSelected) {
      // Check we have a lat long pair
      if (Object.keys(mapParams).indexOf("latitude") === -1) return -1;
      if (Object.keys(mapParams).indexOf("longitude") === -1) return -1;

      cancelTokenSourceRef.current = axios.CancelToken.source();
      try {
        const haveReportId = Object.keys(mapParams).indexOf("reportid") !== -1;
        const url = haveReportId ? "maps/nearbyreport" : "maps/nearby";
        const getParams = mapParams;
        getParams.limit = 16000;
        const res = await api({
          method: "GET",
          url: url,
          params: getParams,
          cancelToken: cancelTokenSourceRef.current.token,
        });

        const totalHeader = res.headers["x-total-count"];

        if (Number(totalHeader) >= getParams.limit) {
          setNearbyItems([]);
          setOverlay(true);
        } else {
          setNearbyItems(
            [].concat(res.data).filter((_) => {
              // return current ? current.id !== _.id : true;
              return true;
            })
          );

          // setCurrent((prev) => {
          //   if (prev?.id) {
          //     const currentNearby = res.data.find((_) => {
          //       return _.id === currentIdRef.current;
          //     });
          //     if (currentNearby) {
          //       return Object.assign({}, prev, { lastPosition: currentNearby });
          //     } else {
          //       // return prev;
          //       // if (!followingRef.current) {
          //       //   return null;
          //       // } else {
          //       //   return prev;
          //       // }
          //     }
          //   } else {
          //     return null;
          //   }
          // });
          // setOverlay(false);
        }
        // bumpGroupsVersion();
        return 0;
      } catch (error) {
        console.warn("load", error);
        return -1;
      } finally {
        if (cancelTokenSourceRef.current) {
          cancelTokenSourceRef.current.cancel("unmount");
          cancelTokenSourceRef.current = null;
        }
      }
    } else {
      cancelTokenSourceRef.current = axios.CancelToken.source();
      // const res = await api.get(`floorplans/nearby?radius=${radiusZoomLevel[Math.round(zoomLevelRef.current)]}&latitude=${mapInstance.getCenter().lat()}&longitude=${mapInstance.getCenter().lng()}&limit=${limit}`, {
      try {
        const res = await api.get(
          `floorplans/nearbyid?id=${mapParams.selectedFloorplanId}`,
          {
            params: {
              limit: 16000,
              hashtag: mapParams.hashtag,
            },
            cancelToken: cancelTokenSourceRef.current.token,
          }
        );

        const totalHeader = res.headers["x-total-count"];
        if (Number(totalHeader) >= 16000) {
          setNearbyItems([]);
          // count[0] = Number(totalHeader);
          setOverlay(true);
        } else {
          setNearbyItems(
            [].concat(res.data).filter((_) => {
              // return current ? current.id !== _.id : true;
              return true;
            })
          );
          setOverlay(false);
        }
      } catch (error) {
        console.warn("load", error);
        return -1;
      } finally {
        if (cancelTokenSourceRef.current) {
          cancelTokenSourceRef.current.cancel("unmount");
          cancelTokenSourceRef.current = null;
        }
      }
    }
    // }, [followCurrent, reportid, hashtag, category, selectedFloorplan]);
  }, []);

  const loadNearby = useCallback(
    throttleAsync(async () => {
      await loadNearbyInner();
    }, 500),
    [loadNearbyInner, throttleAsync]
  );

  const handleAll = () => {
    // If at least one InfoWindow is being displayed, turn all off.
    // If all off, turn all on.
    if (showInfoIds.length === 0) {
      setShowInfoIds(
        nearbyItems
          .filter((_) => {
            return _.type !== "zone";
          })
          .map((_) => {
            return _.id;
          })
      );
    } else {
      setShowInfoIds([]);
    }
  };

  const getDefaultItem = useCallback(async () => {
    if (!map) return;
    // If we have the data param set, then don't get default
    if (!data) {
      if (reportid) {
        let defaultResult = await api.get(`maps/defaultitemreport`, {
          params: {
            reportid: reportid,
          },
        });

        let defaultResultData = defaultResult.data;
        if (!defaultResultData) {
          setCurrent(null);
          setNearbyItems([]);
        } else {
          defaultResultData.type = thingsArr[defaultResultData.type];
          let res = await api.get(
            `${defaultResultData.type}/${defaultResultData.id}`
          );

          let cur = res.data;
          cur.type = defaultResultData.type;
          setCurrent(cur);
        }
      } else {
        let defaultResult = await api.get(`maps/defaultitem`, {
          params: {
            hashtag: hashtag,
            category: category,
          },
        });

        let defaultResultData = defaultResult.data;
        if (!defaultResultData) {
          setCurrent(null);
          setNearbyItems([]);
        } else {
          defaultResultData.type = thingsArr[defaultResultData.type];
          let res = await api.get(
            `${defaultResultData.type}/${defaultResultData.id}`
          );
          let cur = res.data;
          cur.type = defaultResultData.type;
          setCurrent(cur);
        }
      }
    }
  }, [map, data, reportid, hashtag, category]);

  useEffect(() => {
    if (type !== "editReaders" && floorplanMode === "") {
      getDefaultItem();
    }
  }, [getDefaultItem, type]);

  useEffect(() => {
    if (type && user && !user[type]) {
      navigate("/");
      return;
    }
  }, [user, type]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (reportid) {
        setReport(undefined);

        try {
          const reportResult = await api.get(`reports/${reportid}`);

          if (!cancelled && reportResult.status === 200) {
            setReport(reportResult.data);
          }
        } catch (err) {
          if (!cancelled) {
            console.error("Failed to load report:", err);
          }
        }
      }
    })();

    return () => {
      cancelled = true;
      setReport(undefined);
    };
  }, [reportid, setReport]);

  // useEffect(() => {
  //   if (!map) return;

  //   let intervalId = null;
  //   if (showNearByAssets || showNearByZones) {
  //     intervalId = setInterval(() => {
  //       // loadNearbyThrottled();
  //       loadNearby();
  //     }, 5000);
  //     loadNearby();
  //   }

  //   return () => {
  //     if (intervalId) {
  //       clearInterval(intervalId);
  //     }
  //   };
  // }, [map, loadNearby, showNearByAssets, showNearByZones]);

  useEffect(async () => {
    if (!map) return;

    let intervalId = null;
    if (showNearByAssets || showNearByZones) {
      intervalId = setInterval(async () => {
        await followCurrent();
      }, 5000);
      await followCurrent();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [map, followCurrent, showNearByAssets, showNearByZones]);

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        {overlay && (
          <div className="p-3 ps-2 bg-light text-warning">
            Too many items to show. Please zoom or search to narrow results
          </div>
        )}
        {!overlay && !current && firstLoad && (
          <div className="p-3 ps-2 bg-light text-warning">
            No relevant assets/people to show, please select other
            hashtag/category
          </div>
        )}
        {showMapDetail && current ? (
          <MapDetail
            profile={current}
            following={following}
            onChangeToggle={(e) => {
              // follow.current = e.target.checked;
              setFollowing(e.target.checked);
            }}
            fromFloorplan={selectedFloorplan !== null}
          />
        ) : null}
      </div>
      {selectedReader && (
        <Card className="mb-0 border-bottom">
          <Card.Body className="d-flex align-items-center ">
            <NavLink
              to={`/readers/edit?id=${selectedReader.id}&direct=floorplans&fId=${selectedFloorplan?.id}`}
            >
              {selectedReader.serial}
            </NavLink>
            {selectedReader.wirepasNetworkId && (
              <Grid className="ms-2" size={14} />
            )}
            {selectedReader.wirepas && <Link className="ms-1" size={14} />}
            {selectedReader.lastReport && (
              <div className="ms-2">
                <FontAwesomeIcon icon={faHeartbeat} size={"sm"} />
                <span className="ms-2">
                  {moment(selectedReader.lastReport).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )}
                </span>
              </div>
            )}
            {(!selectedReader.latitude || !selectedReader.longitude) && (
              <div className="ms-2">
                <span className="ms-2 text-danger">Not Yet Configured</span>
              </div>
            )}
          </Card.Body>
        </Card>
      )}
      <div
        id="commonMap"
        style={{
          position: "relative",
          width: "100%",
          height: `${height}`,
          overflow: "hidden",
        }}
        className={`${
          selectedFloorplan &&
          !editFloorplanEnabled &&
          (type !== "editReaders" ||
            (type === "editReaders" && floorplanMode === "readerview")) &&
          type !== "editTags" &&
          !(floorplanMode === "geofence")
            ? "hidden-map"
            : ""
        }`}
      >
        <CommonMapContainer
          showStreetView={showStreetView}
          handleMapChange={handleMapChange}
        >
          {showGoogleSearch && <GoogleSearch />}
          <ButtonsControl
            report={report}
            nearbyItems={nearbyItems}
            hashtag={hashtag}
            setHashtag={setHashtag}
            category={category}
            setCategory={setCategory}
            handleAll={handleAll}
            showNearByAssets={showNearByAssets}
            showAllLabels={showAllLabels}
            showHashTagFilter={showHashTagFilter}
            showCategoryFilter={showCategoryFilter}
          />
          {showTrackingSearch && <TrackingSearch report={report} />}
          {/* {!data && (
            <CommonMapDefaultItem
              current={current}
              onCurrentChanged={handleCurrentChanged}
            />
          )} */}
          {showReaders && (
            <MapControl position={ControlPosition.TOP_LEFT}>
              <div
                style={{
                  position: "relative",
                  background: "#ffffffff",
                  margin: "10px",
                }}
              >
                <ReaderSelector
                  reader={selectedReader}
                  getAllReaders={(e) => setReaders(e)}
                  onSelect={onSelectReader}
                  showDefault
                  showReader={showReader}
                />
              </div>
            </MapControl>
          )}
          {(user.showFloorPlans || user.role === "Root") && (
            <CommonMapFloorplans
              mode={floorplanMode}
              data={data}
              // selectedFloorplan={selectedFloorplan}
              // onSelectedFloorplanChanged={handleSelectedFloorplanChanged}
              // onSelectedGeometryChanged={handleSelectedGeometryChanged}
              geofenceFloorplan={geofenceFloorplan}
            />
          )}
          {/* {data &&
            data.lastPosition &&
            data.lastPosition.longitude &&
            data.lastPosition.latitude && (
              <GeoMarker
                item={data}
                img={
                  imageSet[getUrl(data.icon)]
                    ? require("../../assets/img/icon/" +
                        imageSet[getUrl(data.icon)]).default
                    : defaultImg
                }
                lat={Number(data.lastPosition.latitude)}
                lng={Number(data.lastPosition.longitude)}
              />
            )} */}
          {current &&
            !showNearByAssets &&
            current.lastPosition?.latitude &&
            current.lastPosition?.longitude && (
              <GeoMarker
                item={current}
                img={
                  imageSet[getUrl(current.icon)]
                    ? require("../../assets/img/icon/" +
                        imageSet[getUrl(current.icon)]).default
                    : defaultImg
                }
                lat={Number(current.lastPosition?.latitude)}
                lng={Number(current.lastPosition?.longitude)}
              />
            )}
          {(showNearByAssets || showNearByZones) && (
            <CommonMapNearByItems
              showNearByAssets={showNearByAssets}
              showNearByZones={showNearByZones}
              nearbyItems={nearbyItems}
              onCurrentChanged={handleCurrentChanged}
              reportId={reportid}
              report={report}
              clusteredItemIds={clusteredItemIds}
              setClusteredItemIds={setClusteredItemIds}
            />
          )}
          {showTrafficLayer && !selectedFloorplan && <CommonMapTrafficLayer />}
          {children}
        </CommonMapContainer>
      </div>
    </React.Fragment>
  );
};

const GeoMarker = ({ item, img, lat, lng, plan }) => {
  const { itemDisplayName } = useSrlHelper();
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const [markerRef, marker] = useAdvancedMarkerRef(null);
  const [showInfo, setShowInfo] = useState(false);
  const markerImageRef = useRef();
  const [markerPos, setMarkerPos] = useState({ top: 0, left: 0 });

  const displayName = itemDisplayName(item);

  const measurePosition = useCallback(() => {
    if (!map) return;
    if (markerImageRef.current) {
      const markerRect = markerImageRef.current.getBoundingClientRect();
      const mapRect = map.getDiv().getBoundingClientRect();

      setMarkerPos({
        top: markerRect.top - mapRect.top - 8,
        left: markerRect.left - mapRect.left + markerRect.width / 2,
      });
    }
  }, [map]);

  useEffect(() => {
    if (showInfo) {
      measurePosition();
    }
  }, [showInfo, marker?.position]);

  const handleBoundsChange = () => {
    measurePosition();
  };

  useEffect(() => {
    if (!map) return;
    if (!showInfo) return;

    const boundsChangedListener = map.addListener(
      "bounds_changed",
      handleBoundsChange
    );

    const idleListener = map.addListener("idle", handleBoundsChange);

    return () => {
      mapLibCore.event.removeListener(boundsChangedListener);
      mapLibCore.event.removeListener(idleListener);
    };
  }, [map, showInfo]);

  return (
    <React.Fragment>
      {img && (
        <React.Fragment>
          <AdvancedMarker
            position={{
              lat,
              lng,
            }}
            map={map}
            zIndex={200}
            ref={markerRef}
          >
            {marker && (
              <React.Fragment>
                <div
                  style={{ position: "relative", transform: "translateY(50%)" }}
                >
                  <img
                    ref={markerImageRef}
                    src={img}
                    width={24}
                    alt="Marker"
                    onClick={() => {
                      setShowInfo(true);
                    }}
                    className="cursor-pointer"
                  />
                  <div
                    className="px-1 text-nowrap text-black bg-primary bg-opacity-75 rounded"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      marginTop: 4,
                      pointerEvents: "none",
                    }}
                  >
                    {displayName}
                  </div>
                </div>

                {map &&
                  showInfo &&
                  createPortal(
                    <InfoWindow
                      key={item.id}
                      clickTarget={() => {}}
                      show={Object.assign({}, item, { active: true })}
                      onClose={() => {
                        setShowInfo(false);
                      }}
                      anchorPos={markerPos} // 👈 pass measured position
                    />,
                    map.getDiv()
                  )}
              </React.Fragment>
            )}
          </AdvancedMarker>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default CommonMap;
